import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuOperatingCondition,
  SeuOperatingConditionApi,
  SeuSaveOperatingConditionApi,
  SeuToApiConverter,
} from '@seu-types';

export const operatingConditionConverter: SeuApiConverter<
  SeuOperatingCondition,
  SeuOperatingConditionApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      id: String(input.id),
      description: input.description ?? '',
      inputStreams: input.inputStreams.map((inputStream) => ({
        ...inputStream,
        inputs: inputStream.inputs.map(configInputConverter.fromApi),
      })),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      id: Number(input.id),
      description: input.description ?? '',
      categories: input.categories ?? [],
      inputStreams: input.inputStreams.map((inputStream) => ({
        inputStreamId: inputStream.inputStreamId ?? '',
        inputs: inputStream.inputs.map(configInputConverter.toApi),
        version: inputStream.version,
      })),
    };
  },
};

export const saveOperatingConditionConverter: SeuToApiConverter<
  SeuOperatingCondition,
  SeuSaveOperatingConditionApi
> = {
  toApi: (input) => {
    return {
      ...input,
      categories: input.categories ?? [],
    };
  },
};
